import { Grid } from "@mui/material";
import { CustomCheckbox, CustomCalendarTodayOutlinedIcon, CustomDatePicker, CustomInputLabel, CustomRequiredInputLabel, CustomTextFeildforFamily, StyledDateContainer, CommonButton } from "../../common/StyledComponents/StyledFields";
import styles from '../reportSection.module.scss';
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";

const DevoteeReport = ({ sendDataToParent, getReportData }:any) => {

    const formFieldsDevoteeReport = {
        lastNameStartsWith: "",
        zipCode: "",
        city: "",
        email: "",
        signInName: "",
        homePhoneNumber: "",
        workPhoneNumber: "",
        dateOfBirth: "",
        joiningFromDate: "",
        joiningToDate: ""
    }

    const [isNameSelected, setIsNameSelected] = useState(true);
    const [isAddressSelected, setIsAddressSelected] = useState(true);
    const [isSignInSelected, setIsSignInSelected] = useState(false);
    const [isHomePhoneSelected, setIsHomePhoneSelected] = useState(false);
    const [isWorkPhoneSelected, setIsWorkPhoneSelected] = useState(false);
    const [isEmailSelected, setIsEmailSelected] = useState(false);
    const [isPreffLangSelected, setIsPreffLangSelected] = useState(false);
    const [isDobSelected, setIsDobSelected] = useState(false);
    const [isSerialNumSelected, setIsSerialNumSelected] = useState(false);
    const [noOfColumns, setNoOfColumns] = useState<number>(0);

    const [formDataDevoteeReport, setFormDataDevoteeReport] = useState(formFieldsDevoteeReport);
    
    const handleFieldChange = (field: any, value: any) => {
        if (field === "dateOfBirth" || field === "joiningFromDate" || field === "joiningToDate") {
            const formattedDate = dayjs(value, "MM/DD/YYYY");
            setFormDataDevoteeReport({
              ...formDataDevoteeReport,
              [field]: formattedDate.isValid()
                ? formattedDate.format("MM/DD/YYYY")
                : "",
            });
        } else {
            setFormDataDevoteeReport({
            ...formDataDevoteeReport,
            [field]: value,
            });
        }
    };

    const handlSubmitDevoteereport = () => {
        let reqBody:any = {
            "reportCustomOutputFields": {
                "name": true,
                "address": true
            }
        };
        const valueSelected:any = Object.entries(formDataDevoteeReport).reduce((a,[k,v]) => (v === "" ? a : ((a as any)[k]=v, a)), {});
        reqBody = {
            ...reqBody,
            ...valueSelected
        }
        if(isSignInSelected) {
            reqBody.reportCustomOutputFields.signInName = isSignInSelected;
        }
        if(isHomePhoneSelected) {
            reqBody.reportCustomOutputFields.homePhone = isHomePhoneSelected;
        }
        if(isWorkPhoneSelected) {
            reqBody.reportCustomOutputFields.workPhone = isWorkPhoneSelected;
        }
        if(isEmailSelected) {
            reqBody.reportCustomOutputFields.email = isEmailSelected;
        }
        if(isPreffLangSelected) {
            reqBody.reportCustomOutputFields.preferredLanguage = isPreffLangSelected;
        }
        if(isDobSelected) {
            reqBody.reportCustomOutputFields.dateOfBirth = isDobSelected;
        }
        if(isSerialNumSelected) {
            reqBody.reportCustomOutputFields.serialNumber = isSerialNumSelected;
        }
        reqBody.reportCustomOutputFields.numberOfColumns = noOfColumns;
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/devotee/DEVOTEE_REPORT/browser',
            body: JSON.stringify(reqBody),
            includeToken:true
          })
          .then((res) => {
            sendDataToParent(true);
            getReportData(res.data);
          })
          .catch((err) => {
          })
    };

    const handlSubmitZipcodereport = () => {
        const reqBody = {
            zipcodeAndNumberOfDevotees: true
        };
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/devotee/NUMBER_OF_DEVOTEES_AND_ZIPCODE_REPORT/browser',
            body: JSON.stringify(reqBody),
            includeToken:true
          })
          .then((res) => {
            sendDataToParent(true);
            getReportData(res.data);
          })
          .catch((err) => {
          })
    };

    

    const DobDatePickerDevoteeReport = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
                <StyledDateContainer className={styles.styledConatiner}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataDevoteeReport.dateOfBirth ? dayjs(formDataDevoteeReport.dateOfBirth, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    handleFieldChange('dateOfBirth', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const JoiningDateFrom = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
                <StyledDateContainer className={styles.styledConatiner}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataDevoteeReport.joiningFromDate ? dayjs(formDataDevoteeReport.joiningFromDate, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    handleFieldChange('joiningFromDate', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const JoiningDateTo = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
                <StyledDateContainer className={styles.styledConatiner}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataDevoteeReport.joiningToDate ? dayjs(formDataDevoteeReport.joiningToDate, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    handleFieldChange('joiningToDate', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const handleClear = () => {
        setFormDataDevoteeReport(formFieldsDevoteeReport);
    }

    return (
        <div>
            <Grid container spacing={6} sx={{ marginTop: '0px' }}>
                <Grid item xs={12} sm={8}>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Last Name Starts With</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.lastNameStartsWith}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("lastNameStartsWith", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Zip Code</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.zipCode}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("zipCode", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>City</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.city}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("city", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Email</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.email}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("email", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Sign-in Name</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.signInName}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("signInName", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Home Phone Number</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.homePhoneNumber}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("homePhoneNumber", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Work Phone Number</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                // value={formFieldsDevoteeReport.workPhoneNumber}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    handleFieldChange("workPhoneNumber", inputValue);
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            {CustomRequiredInputLabel("Date Of Birth", false)}
                            {DobDatePickerDevoteeReport()}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0 }}>
                        <Grid item xs={12} sm={6}>
                            {CustomRequiredInputLabel("Joining Date From", false)}
                            {JoiningDateFrom()}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {CustomRequiredInputLabel("Joining Date To", false)}
                            {JoiningDateTo()}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0 }}>
                        <Grid item xs={12} sm={2}>
                            <CommonButton onClick={handlSubmitDevoteereport}>Submit</CommonButton>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CommonButton onClick={handlSubmitZipcodereport}>Zipcode and No of Devotees</CommonButton>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <CommonButton onClick={handleClear}>Reset</CommonButton>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Name
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isNameSelected}
                                onChange={() => setIsNameSelected(!isNameSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Address
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isAddressSelected}
                                onChange={() => setIsAddressSelected(!isAddressSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Sign-in Name
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isSignInSelected}
                                onChange={() => setIsSignInSelected(!isSignInSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Home Phone
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isHomePhoneSelected}
                                onChange={() => setIsHomePhoneSelected(!isHomePhoneSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Work Phone
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isWorkPhoneSelected}
                                onChange={() => setIsWorkPhoneSelected(!isWorkPhoneSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Email
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isEmailSelected}
                                onChange={() => setIsEmailSelected(!isEmailSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Preferred Language
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isPreffLangSelected}
                                onChange={() => setIsPreffLangSelected(!isPreffLangSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Date of Birth
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isDobSelected}
                                onChange={() => setIsDobSelected(!isDobSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={12}>
                            <div style={{display: "flex"}}>
                                <CustomInputLabel style={{alignSelf: "center"}}>
                                    Serail Number
                                </CustomInputLabel>
                                <CustomCheckbox
                                checked={isSerialNumSelected}
                                onChange={() => setIsSerialNumSelected(!isSerialNumSelected)}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <Grid item xs={12} sm={4}>
                            <CustomInputLabel>Number of columns</CustomInputLabel>
                            <CustomTextFeildforFamily
                                style={{ minWidth: '100%', borderRadius: "8px" }}
                                fullWidth
                                value={noOfColumns}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setNoOfColumns(Number(inputValue));
                                }}
                                className={styles.dateFeild}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
};

export default DevoteeReport;